import { render, staticRenderFns } from "./block-user-organizations.vue?vue&type=template&id=4e43c4aa&scoped=true&lang=pug"
import script from "./block-user-organizations.vue?vue&type=script&lang=js"
export * from "./block-user-organizations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e43c4aa",
  null
  
)

export default component.exports